import React, { Component } from "react";
import "./Home.css";
import { Well,Alert, ListGroup ,ListGroupItem ,ButtonGroup ,Button,Jumbotron,FormGroup,ControlLabel,FormControl} from "react-bootstrap";
import { API } from "aws-amplify";
import Moment from 'react-moment';
import AUTHMD from '../md/HomeAuthenticated.md'
import UNAUTHMD from '../md/HomeUnAuthenticated.md'
import LoaderButton from "../components/LoaderButton";
import ReactMarkdown from 'react-markdown/with-html'


export default class Home extends Component {
    constructor(props) {
      super(props);
      this.state = {
          altiom:[],
          myaltioms_fetching:true,
          markdown:"",
          newUser:false,
          responce:"",
          isLoading:false,
          webresponce:""

      };
    }
    async componentWillMount() {
      const data = await this.getInfo();
      console.log(data)
      this.setState(data)
      console.log(this.state)
    }
    responceChanged=(e)=>{
      console.log(e.target.value)
      this.setState({responce:e.target.value})


    }
    validateForm(){
      if (this.state.responce.length>3)
        return true
      return false
    }

    handleSubmit = async event => {
      event.preventDefault();

      this.setState({ isLoading: true });

      //send a request to the welcome function with some extra qyery parameters
      const responce=await this.getAccess(this.state.responce);
      console.log(responce)
      this.setState({ isLoading: false });
      this.setState(responce)
      this.setState({ webresponce:responce.code})
      this.setState({ markdown:responce.markdown})
      this.setState({ newUser:true})
      console.log(responce.code)
    //  this.setState(data)
    //  console.log(this.state)
    }
    getAccess(note){
      let data = {
        'queryStringParameters': {
            'note': note,
            'newUser': true
        }
      }
      return API.get("AltiomData", "/welcome",data);
    }
    getInfo() {
      return API.get("AltiomData", "/welcome");
    }

    showauthcode=(e)=>{
        console.log("Show auth")
        this.setState({newUser:true})
    }
sorrArrayKey=(a,b,key)=>{
  if(a[key]<b[key]){
    return -1
  }
  if(a[key]>b[key]){
    return 1
  }
  return 0
}

    render() {
      return (
          <div className="Home">
          <Jumbotron>
            <ReactMarkdown  source={this.state.markdown}  escapeHtml={false}/>
            {this.state.newUser ? (
              <form onSubmit={this.handleSubmit}>

              <FormGroup controlId="formControlsTextarea">
                  <ControlLabel>Request</ControlLabel>
                  <FormControl componentClass="textarea" placeholder="Insert request here" value={this.state.responce} onChange={this.responceChanged} rows="8"/>
                  <br/>
                  {this.state.webresponce.length>0 ? (
                  <Alert bsStyle="danger">
                    <strong>Code:</strong> {this.state.webresponce}
                  </Alert>):<span></span>}
                  <LoaderButton
                    bsSize="large"
                    disabled={!this.validateForm()}
                    type="submit"
                    isLoading={this.state.isLoading}
                    text="Submit Request"
                    loadingText="Submitting..."
                      />
                      <Button bsSize="large" href="/a" >Back</Button>
              </FormGroup>
              </form>
              ) : (
                  <div>
                  {this.state.altiom.sort((a,b)=>this.sorrArrayKey(a,b,'name')).map((l) =>(
                      <div key={l.id}>
                          {l.id.length<=16 ?
                            (<a key={l.id} href={"/a/"+l.id}><Well > {l.name}  </Well></a>)
                            :
                            (
                              <span>
                              {
                                l.mode=="Temp"? (<a key={l.id} href={"/b/"+l.id+"/temperature"}><Well ><i className={"fa fa-thermometer-half"}></i> {l.name} </Well></a>):("")
                              }

                                {l.mode=="Normal"  ? (<a key={l.id} href={"/b/"+l.id}><Well > {l.name}</Well></a>):("")}

                                {l.mode=="door" ? (<a key={l.id} href={"/door/"+l.id}><Well > {l.name}</Well></a>):("")}


                                {l.mode=="Sms" ? (<a key={l.id} href={"/sms/"+l.id}><Well ><i className={"fa fa-mobile"}></i> {l.name} </Well></a>):("")}



                              </span>
                            )
                          }
                  </div>))
                }

                  <hr/>
                  <a className="pull-right" onClick={this.showauthcode}>Enter Another Auth Code</a>
                  </div>
              )}
            </Jumbotron>
          </div>
        );
    }
}

//{this.props.isAuthenticated ? <ReactMarkdown className="CenterText" source={this.state.md_auth}  escapeHtml={false} /> : <ReactMarkdown className="CenterText" source={this.state.md_unauth}  escapeHtml={false}/>}



// WEBPACK FOOTER //
// ./src/containers/AltiomList.js